import { useEffect, useState } from "react";
import { useStore } from "../../store";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { screensaverMp4 } from "../../assets";


function Screensaver() {
  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;



  const time = !!!resData.loadSettingAck?.screenLockEnabled ? 0 : Number((resData.loadSettingAck?.screensaverWaitTime || 0)) * 1000 * 60
  // const time = 2000

  const [showScreensaver, setShowScreensaver] = useState(false);

  const [spinner, setSpinner] = useState(false)


  useEffect(() => {

    if (spinner) {
      setTimeout(() => {
        setSpinner(false)
      }, 500)
    }

  }, [spinner])


  useEffect(() => {
    let timeout: any

    const resetTimeout = () => {
      if (time <= 0) return
      clearTimeout(timeout);
      setShowScreensaver(false);
      timeout = setTimeout(() => setShowScreensaver(true), time);
    };

    const handleActivity = () => {
      resetTimeout()
    };


    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("mousedown", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("scroll", handleActivity);
    window.addEventListener("touchstart", handleActivity);
    window.addEventListener("touchend", handleActivity);
    window.addEventListener("touchmove", handleActivity);

    resetTimeout();

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("mousedown", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      window.removeEventListener("touchend", handleActivity);
      window.removeEventListener("touchmove", handleActivity);
      clearTimeout(timeout);
    };
  }, [time]);


  if (time <= 0) return (<div />)

  // 阻止事件穿透
  const handleStopPropagation = (e: any) => {
    e?.stopPropagation && e.stopPropagation();
    setSpinner(true)
  };

  return (
    <>
      {showScreensaver && (
        <div
          onMouseUp={handleStopPropagation} // 阻止鼠标按下事件
          onMouseDown={handleStopPropagation} // 阻止鼠标按下事件
          onClick={handleStopPropagation} // 阻止点击事件
          onTouchStart={handleStopPropagation} // 阻止触摸开始事件
          onTouchEnd={handleStopPropagation} // 阻止触摸结束事件
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "black",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <video autoPlay loop muted className="w-[1280px] h-[800px]">
            <source src={screensaverMp4} type="video/webm" />
          </video>


        </div>
      )}
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9998,
          }}
        />
      )}

    </>
  );
}
export default observer(Screensaver);
